module.exports = __webpack_public_path__ + "images/views/BoardViewsButtonCalloutImage.9d38bb6fb1ed06b64de0.svg";